import React, {Component} from 'react'
import { findDOMNode } from 'react-dom'
import Waypoint from '../Waypoint'
import { setSectionProperty } from '../../actions/sections/SectionsActions'
import Heading from 'grommet/components/Heading'
import { connect } from 'react-redux'
import './ServicesList.css'

@connect((state) => ({}), { setSectionProperty })
class ServicesList extends Component {
  updatePositions = (position) => {
    var perc = (position.waypointTop - position.scrollTop) / position.height
    const services = findDOMNode(this).getElementsByClassName('ServicesList-service')
    const serv1 = services[0],
    serv2 = services[1],
    serv3 = services[2],
    serv4 = services[3],
    serv5 = services[4],
    serv6 = services[5]

    serv1.style.opacity = 1 - perc * 1
    serv2.style.opacity = 1 - perc * 1.5
    serv3.style.opacity = 1 - perc * 2
    serv4.style.opacity = 1 - perc * 2.5
    serv5.style.opacity = 1 - perc * 3
    serv6.style.opacity = 1 - perc * 3.5
  }

  handleEnter = () => {
    //const { setSectionProperty } = this.props
    // setSectionProperty('about', 'separatorBarExpanded', true)
  }

  render() {
    return (
      <div className="ServicesList">
        <Waypoint threshold={0.1} onUpdate={this.updatePositions} scrollableAncestor={window}/>
        <div className="ServicesList-featuresBlock">
          <div className="ServicesList-featuresBlockCol1">
            <Heading tag="h1" className="ServicesList-service" uppercase={true} strong={true}>Web
              Development</Heading>
            <Heading tag="h1" className="ServicesList-service" uppercase={true} strong={true}>Front
              end</Heading>
            <Heading tag="h1" className="ServicesList-service" uppercase={true} strong={true}>Software</Heading>
          </div>
          <div className="ServicesList-featuresBlockCol2">
            <Heading tag="h1" className="ServicesList-service" uppercase={true} strong={true}>User
              Experience</Heading>
            <Heading tag="h1" className="ServicesList-service" uppercase={true}
                     strong={true}>Strategy</Heading>
            <Heading tag="h1" className="ServicesList-service" uppercase={true} strong={true}>Mobile Apps</Heading>
          </div>
        </div>
      </div>
    )
  }
}

export default ServicesList


// WEBPACK FOOTER //
// ./src/components/ServicesList/index.js